import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as seasonsActions from '../../../actions/seasons';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';

class SeasonsContainer extends Component {

    componentWillMount() {
        this.props.actions.fetchSeasons();
    }

    render() {
        const {items, total, page, loading} = this.props.seasons;

        var config = {
            cols: [
                {
                    value: 'name',
                    header: LocalizedStrings.name
                }, {
                    value: 'order',
                    header: LocalizedStrings.order
                }, {
                    value: (item) => {

                        return (
                            <Link to={`/admin/seasons/${item.id}`} className="btn">{LocalizedStrings.edit}</Link>
                        )
                    },
                    header: LocalizedStrings.actions
                }
            ]
        };
        return (


            <div>
                <h3>{LocalizedStrings.seasons}</h3>
                <div className="table-actions-row">
                    <Link to="/admin/seasons/new" className="btn btn-primary">
                        {LocalizedStrings.newSeason}
                    </Link>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <DataTable config={config} items={items} page={page} total={total}
                                   loading={loading}/>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(function (state) {
    return {seasons: state.season.seasons};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...seasonsActions
        }, dispatch)
    };
})(SeasonsContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/season/seasons-container.js